import { api } from '@services/Api';


const mapSelectDateOptions = (title, opts) => {
  return opts?.map((m) => {
    return {
      title: title,
      label: m.dayOfWeek,
      value: `${m.start}, ${m.end}`,
    }
  })
}

export const transformUserResponse = (data: any) => {

  const newReleaseOptions = [
    {
      label: 'Current Week',
      options: mapSelectDateOptions('Current Week', [data.newReleaseWeeks.currentWeek]),
    },
    {
      label: 'Future Week',
      options: mapSelectDateOptions('Future Week', data.newReleaseWeeks.futureWeeks),
    },
    {
      label: 'Past Week',
      options: mapSelectDateOptions('Past Week', data.newReleaseWeeks.pastWeeks),
    }
  ];

  const focWeeksOptions = [
    {
      label: 'Current Week',
      options: mapSelectDateOptions('Current Week', [data.focWeeks.currentWeek]),
    },
    {
      label: 'Future Week',
      options: mapSelectDateOptions('Future Week', data.focWeeks.futureWeeks),
    },
    {
      label: 'Past Week',
      options: mapSelectDateOptions('Past Week', data.focWeeks.pastWeeks),
    }
  ];

  const partner = {
    id: 1,
    businessName: data?.partner?.business_name
      ? data.partner.business_name
      : null,
    code: data?.partner?.code
      ? data.partner.code
      : null,
    email: data?.partner.email
      ? data.partner.email
      : null,
    billingAddress: data?.partner?.billing_address
      ? data.partner.billing_address
      : null,
    pointOfContactUserId: data?.partner?.point_of_contact_user_id
      ? data.partner.point_of_contact_user_id
      : null,
    customerServiceUserId: data?.partner?.customer_service_user_id
      ? data.partner.customer_service_user_id
      : null,
    partnerLogoUrl: data?.partner?.partner_logo_url
      ? data.partner.partner_logo_url
      : null,
    partnershipStartDate: data?.partner?.partnership_start_date
      ? data.partner.partnership_start_date
      : null,
    newReleaseDay: data?.partner?.new_release_day
      ? data.partner.new_release_day
      : null,
    finalOrderCutOffDay: data?.partner?.final_order_cut_off_day
      ? data.partner.final_order_cut_off_day
      : null,
    partnerPlatformId: data?.partner?.partner_platform_id
      ? data.partner.partner_platform_id
      : null,
    createdAt: data?.partner?.created_at
      ? data.partner.created_at
      : null,
    updatedAt: data?.partner?.updated_at
      ? data.partner.updated_at
      : null,
  }

  const customerServiceRep = {
    id: data?.partnerCustomerServiceRep?.ID
      ? data.partnerCustomerServiceRep.ID
      : null,
    userLogin: data?.partnerCustomerServiceRep?.user_login
      ? data.partnerCustomerServiceRep.user_login
      : null,
    userNicename: data?.partnerCustomerServiceRep?.user_nicename
      ? data.partnerCustomerServiceRep.user_nicename
      : null,
    userEmail: data?.partnerCustomerServiceRep?.user_email
      ? data.partnerCustomerServiceRep.user_email
      : null,
    userUrl: data?.partnerCustomerServiceRep?.user_url
      ? data.partnerCustomerServiceRep.user_url
      : null,
    userRegistered: data?.partnerCustomerServiceRep?.user_registered
      ? data.partnerCustomerServiceRep.user_registered
      : null,
    userActivationKey: data?.partnerCustomerServiceRep?.user_activation_key
      ? data.partnerCustomerServiceRep.user_activation_key
      : null,
    userStatus: data?.partnerCustomerServiceRep?.user_status
      ? data.partnerCustomerServiceRep.user_status
      : null,
    displayName: data?.partnerCustomerServiceRep?.display_name
      ? data.partnerCustomerServiceRep.display_name
      : null,
  }

  const partnerPlatform = {
    id: data?.partnerPlatform?.id
      ? data.partnerPlatform.id
      : null,
    name: data?.partnerPlatform?.name
      ? data.partnerPlatform.name
      : null,
    code: data?.partnerPlatform?.code
      ? data.partnerPlatform.code
      : null,
    description: data?.partnerPlatform?.description
      ? data.partnerPlatform.description
      : null,
    createdAt: data?.partnerPlatform?.created_at
      ? data.partnerPlatform.created_at
      : null,
    updatedAt: data?.partnerPlatform?.updated_at
      ? data.partnerPlatform.updated_at
      : null,
  }

  const lastDownloadedFiles = data.lastDownloadedFiles
    ?.map((f) => {
      return {
        name: f?.file_name ? f.file_name : null,
        type: f?.file_name_prefix ? f.file_name_prefix : null,
        date: f?.file_date ? f.file_date : null,
        updatedAt: f?.updated_at ? f.updated_at : null,
      }
    })

  const partnerPointOfContact = data.partnerPointOfContact;

  return ({
    partner,
    partnerPointOfContact,
    lastDownloadedFiles,
    newReleaseOptions,
    focWeeksOptions,
    partnerPlatform,
    customerServiceRep,
  })
};

export const transformExportableFieldsResponse = (data: any) => {

  const newShape = data.map((item) => {
    return {
      id: item.id,
      partnerPlatformId: item.partner_platform_id,
      name: item.name,
      code: item.code,
      description: item.description,
      niceName: item.nice_name,
      type: item.type,
      required: item.required,
      custom: item.custom,
      createdAt: item.created_at,
      updatedAt: item.updated_at,
      active: item.active,
    }
  })

  const options: any = newShape
    ?.map((field) => {
      return {
        ...field,
        label: field.niceName,
        value: field.id,
      }
    });

  const activeIds = newShape
    ?.filter(field => !!field.active)
    ?.map(field => field.code)

  return {
    options,
    activeIds
  };
};

const partnersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPartnerData: build.query<any, any>({
      query: (args) => {
        return {
          url: `covr/v1/partner-portal/partner/main/?userId=${args.userId}`,
          method: "GET",
        };
      },
      providesTags: ['PartnerPortal'],
      transformResponse: transformUserResponse,
    }),
    getPartnerExportableFields: build.query<any, any>({
      query: (args) => {
        return {
          url: `covr/v1/partner-portal/exportable-fields/?userId=${args.userId}`,
          method: "GET",
        };
      },
      providesTags: ['ExportableFields'],
      transformResponse: transformExportableFieldsResponse,
    }),
    getSubscriptionsByPartnerId: build.query<any, any>({
      query: (args) => {
        return {
          url: `covr/v1/partner-portal/partner/subscriptions/?userId=${args.userId}`,
          method: "GET",
        };
      },
      providesTags: ['PartnerSubscriptions'],
    }),
    partnerAddRemoveExportableField: build.mutation({
      query: (payload) => {
        return {
          url: `covr/v1/partner-portal/partner/exportable-field`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ['ExportableFieldsSetActive'],
    }),
    partnerAddRemoveExportableFields: build.mutation({
      query: (payload) => {
        return {
          url: `covr/v1/partner-portal/partner/exportable-fields`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ['ExportableFieldsSetActive'],
    }),
    partnerAddRemoveIssueFromExport: build.mutation({
      query: (payload) => {
        return {
          url: `covr/v1/partner-portal/issue-exclusion`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ['PartnerExportIssueExclusion'],
    }),
    partnerPortalPasswordUpdate: build.mutation({
      query: (payload) => {
        return {
          url: `covr/v1/partner-portal/partner/password/update`,
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: ['Account'],
    }),
  })
});

export const {
  useGetPartnerDataQuery,
  useGetSubscriptionsByPartnerIdQuery,
  useGetPartnerExportableFieldsQuery,
  usePartnerAddRemoveExportableFieldMutation,
  usePartnerAddRemoveExportableFieldsMutation,
  usePartnerAddRemoveIssueFromExportMutation,
  usePartnerPortalPasswordUpdateMutation,
} = partnersApi;
